import { createFileRoute } from '@tanstack/react-router';

import { TeamForm } from '../-components/TeamForm';

export const Route = createFileRoute('/_authenticated/teams/iceHockeyTeams/new')({
    component: () => <TeamForm sportType="iceHockey" />,
});
